import { render } from "./PuppyTraining.vue?vue&type=template&id=5b274e9a&scoped=true"
import script from "./PuppyTraining.vue?vue&type=script&lang=js"
export * from "./PuppyTraining.vue?vue&type=script&lang=js"

import "./PuppyTraining.vue?vue&type=style&index=0&id=5b274e9a&scoped=true&lang=postcss"
/* custom blocks */
import block0 from "./PuppyTraining.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b274e9a"]])

export default __exports__